import { Paper } from "@mui/material";
import React from "react";

const AppContainer = ({ children, styleProps }) => {
  return (
    <Paper
      sx={{
        boxShadow: 1,
        borderRadius: "12px",
        ...styleProps,
      }}
    >
      {children}
    </Paper>
  );
};

export default AppContainer;
